import React, { useEffect, useRef } from 'react';
import { ChevronRight } from 'lucide-react';

export default function HeaderMenu({ requestNumber, status, onCopy, onCancel, onClose }) {
  const ref = useRef(null);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [onClose]);

  const canCancel = status && !['CANCELLED', 'ORDER', 'REJECTED'].includes(status);

  return (
    <div ref={ref} className="absolute top-full left-0 mt-1 z-50 bg-card border rounded-xl shadow-xl p-5 min-w-[600px]">
      <div className="grid grid-cols-3 gap-6">
        <div>
          <p className="font-bold text-sm mb-3">Menu</p>
          {['Originator Details', 'Buyer Details', 'Delivery Point Details'].map(item => (
            <button key={item} className="flex items-center gap-1.5 text-sm text-primary hover:underline py-1.5 w-full border-b last:border-0">
              <ChevronRight className="h-3.5 w-3.5" />{item}
            </button>
          ))}
        </div>
        <div>
          <p className="font-bold text-sm mb-3">Actions</p>
          <button className="flex items-center gap-1.5 text-sm text-primary hover:underline py-1.5" onClick={() => { onClose(); onCopy(); }}>
            <ChevronRight className="h-3.5 w-3.5" />Copy Request
          </button>
          {canCancel && (
            <button className="flex items-center gap-1.5 text-sm text-red-600 hover:underline py-1.5" onClick={() => { onClose(); onCancel(); }}>
              <ChevronRight className="h-3.5 w-3.5" />Cancel Request
            </button>
          )}
        </div>
        <div>
          <p className="font-bold text-sm mb-3">Reports</p>
          <button className="flex items-center gap-1.5 text-sm text-primary hover:underline py-1.5">
            <ChevronRight className="h-3.5 w-3.5" />Request Document
          </button>
        </div>
      </div>
    </div>
  );
}
